import React, { useState } from "react";
import { Box, Chip, OutlinedInput } from "@mui/material";

function PillInput({ values = [], onChange }) {
	const [inputValue, setInputValue] = useState("");

	const delimiters = [",", " ", "\n", "\t"];

	const handleAddPills = (input) => {
		const parts = input
			.split(new RegExp(`[${delimiters.join("")}]`))
			.map((p) => p.trim())
			.filter((p) => p.length > 0);

		if (parts.length) {
			const newValues = [...values];
			parts.forEach((part) => {
				if (!newValues.includes(part)) {
					newValues.push(part);
				}
			});
			onChange(newValues);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			handleAddPills(inputValue);
			setInputValue("");
		}
		// ✅ Backspace deletes last chip if input is empty
		else if (e.key === "Backspace" && inputValue === "" && values.length > 0) {
			onChange(values.slice(0, values.length - 1));
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const text = e.clipboardData.getData("text");
		handleAddPills(text);
		setInputValue("");
	};

	const handleDelete = (chipToDelete) => {
		onChange(values.filter((chip) => chip !== chipToDelete));
	};

	return (
		<OutlinedInput
			fullWidth
			multiline
			value={inputValue}
			onChange={(e) => setInputValue(e.target.value)}
			onKeyDown={handleKeyDown}
			onPaste={handlePaste}
			placeholder="Enter values"
			startAdornment={
				<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
					{values.map((chip, index) => (
						<Chip
							key={index}
							label={chip}
							onDelete={() => handleDelete(chip)}
							size="small"
							sx={{
								bgcolor: "grey",
								color: "primary.contrastText",
								fontWeight: "bold",
								borderRadius: "16px",
								height: 26,
							}}
						/>
					))}
				</Box>
			}
			sx={{
				alignItems: "flex-start",
				".MuiInputBase-input": {
					display: "inline-block",
					width: "auto",
					minWidth: "120px",
					flex: 1,
					padding: "0px 0",
					marginLeft: "6px",
				},
			}}
		/>
	);
}

export default PillInput;
